import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import {
  scheduleMessage as scheduleMessageApi,
  getScheduledMessage as getScheduledMessageApi,
} from 'util/Api/customer';

export const setTempScheduleMessage = createAction('scheduleMessage/setTempScheduleMessage');
export const resetScheduleMessage = createAction('scheduleMessage/resetScheduleMessage');

export const scheduleMessage = createAsyncThunk(
  'scheduleMessage/save',
  async ({ sendTo, dripMessages, sendAs, id }, { rejectWithValue }) => {
    try {
      return await scheduleMessageApi({ sendTo, dripMessages, sendAs, id });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const getScheduledMessage = createAsyncThunk(
  'scheduleMessage/fetch',
  async ({ id }, { rejectWithValue }) => {
    try {
      return await getScheduledMessageApi({ id });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
